import React from "react";
import { Text } from "../../../services/visualLibraryService";
import { HeadingStyled, AccountStatusWrapper } from "../styles/Styled";
import { i18n } from "../../../services/i18nService";
import { isUserAccountActive } from "../../../services/accountStatusService";

export const AccountStatus = ({ userAccount = {} }) => {
  const { settings } = userAccount;
  const accountStatusMessage =
    settings &&
    settings.accountStatus &&
    isUserAccountActive(settings.accountStatus) &&
    `${i18n.get("pages.settings.accountStatus.subscription")} ${i18n.get(
      `pages.settings.accountStatus.statusValue.${settings.accountStatus.toLowerCase()}`
    )}.`;
  const nextBillingDate = getNextBillingDate(userAccount);
  const nextBillingDateMessage =
    getInvalidStatusMessage(settings && settings.accountStatus && settings.accountStatus.toLowerCase()) ||
    (nextBillingDate && buildNextBillingDateMessage(getRequestedState(userAccount), nextBillingDate));

  return (
    <AccountStatusWrapper>
      <HeadingStyled rank={2} text={i18n.get("pages.settings.accountStatus.status")} size="medium" />
      {accountStatusMessage && <Text text={accountStatusMessage} />}
      {nextBillingDateMessage && <Text text={nextBillingDateMessage} />}
    </AccountStatusWrapper>
  );
};

function hasSubscriptions(account) {
  return account && account.billing && account.billing.subscriptions && account.billing.subscriptions[0];
}

// TODO Too many details about the underlying user data structure are exposed here (and in settings in general)
function getNextBillingDate(account) {
  return hasSubscriptions(account) && account.billing.subscriptions[0].nextBillingDate;
}

function getRequestedState(account) {
  return hasSubscriptions(account) && account.billing.subscriptions[0].requestedState;
}

function buildNextBillingDateMessage(requestedState, nextBillingDate) {
  switch (requestedState) {
    case "self-deactivated":
    case "disconnected":
      return `${i18n.get("pages.settings.accountStatus.deactivated", nextBillingDate)}`;
    default:
      return `${i18n.get("pages.settings.accountStatus.renewed")} ${nextBillingDate}`;
  }
}

function getInvalidStatusMessage(currentStatus) {
  switch (currentStatus) {
    case "self-deactivated":
    case "disconnected":
    case "prospect":
      return i18n.get("global.errors.account.invalidStatus");
    default:
      return false;
  }
}
